export const levels = [
  'Company',
  'Warehouse',
  'Pos',
  // 'User'
];

export const integrationTypes = [
  {
    key: 'payment',
    name: 'Payment Terminal',
  },
  {
    key: 'printer',
    name: 'Printer',
  },
  {
    key: 'cashDrawer',
    name: 'Cash Drawer',
  },
  {
    key: 'customerDisplay',
    name: 'Customer Display',
  },
  {
    key: 'scale',
    name: 'Scale',
  },
  {
    key: 'fiscalRegister',
    name: 'Fiscal Register',
  },
  {
    key: 'idCard',
    name: 'ID Card',
  },
];

export const entityMapper = {
  chase: {
    id: 'chase',
    name: 'Chase',
    type: 'payment',
    entity: '',
  },
  wrapper: {
    id: 'wrapper',
    name: 'Wrapper',
    type: 'payment',
    entity: '',
  },
  netsCloud: {
    id: 'netsCloud',
    name: 'Nets Finland',
    type: 'payment',
    entity: '',
  },
  adyen: {
    id: 'adyen',
    name: 'Adyen',
    type: 'payment',
    entity: 'adyen-integration',
  },
  verifone: {
    id: 'verifone',
    name: 'Verifone',
    type: 'payment',
    entity: 'verifone-fin',
  },
  triPOS: {
    id: 'triPOS',
    name: 'TriPOS',
    type: 'payment',
    entity: 'vantiv-tripos-golang-microservice',
  },
  junction: {
    id: 'junction',
    name: 'Junction',
    type: 'payment',
    entity: '',
  },
  moneris: {
    id: 'moneris',
    name: 'Moneris',
    type: 'payment',
    entity: 'moneris-integration',
  },
  pax: {
    id: 'pax',
    name: 'PAX Heartland',
    type: 'payment',
    entity: 'pax-poslink-integration',
  },
  linkpos: {
    id: 'linkpos',
    name: 'Linkpos',
    type: 'payment',
    entity: 'linkpos-integration',
  },
  fiscalRegister: {
    id: 'fiscalRegister',
    name: 'Fiscal Register France',
    type: 'fiscalRegister',
    entity: 'transaction-chain',
  },
  miniScale: {
    id: 'miniScale',
    name: 'Mini Scale',
    type: 'scale',
    entity: 'sweda34f-scale',
  },
  pcEftpos: {
    id: 'pcEftpos',
    name: 'PC-Eftpos',
    type: 'payment',
    entity: 'pc-eftpos-integration',
  },
  cayan: {
    id: 'cayan',
    name: 'Cayan',
    type: 'payment',
    entity: 'cayan-integration',
  },
  swedbank: {
    id: 'swedbank',
    name: 'Swedbank Ingenico',
    type: 'payment',
    entity: 'swedbank-ingenico',
  },
  tsysCanada: {
    id: 'tsysCanada',
    name: 'Tsys Canada',
    type: 'payment',
    entity: '',
  },
  'givex-direct-driver': {
    id: 'givexDirectDriver',
    name: 'Givex Direct driver',
    type: '',
    entity: '',
  },
  'extdev-microservice-customer-display': {
    id: 'extdevCustomerDisplay',
    name: 'Microservice of external devices',
    type: 'customerDisplay',
    entity: 'extdev-microservice',
  },
  'extdev-microservice-scale': {
    id: 'extdevScale',
    name: 'Microservice of external devices',
    type: 'scale',
    entity: 'extdev-microservice',
  },
  'fairbanks-scale': {
    id: 'fairbanksScale',
    name: 'Fairbanks scale',
    type: 'scale',
    entity: 'scale-fairbanks',
  },
  'extdev-microservice-id-card': {
    id: 'extdevIdCard',
    name: 'Microservice of external devices',
    type: 'idCard',
    entity: 'extdev-microservice',
  },
};

/* 
Search integration entities by type and convert result to array of objects.
*/
export const integrationsByType = (type) =>
  Object.entries(entityMapper)
    .filter(([, integration]) => integration.type === type)
    .map(([key, integration]) => ({ key, ...integration }));

export const msByIntegration = (integrationName) =>
  entityMapper[integrationName]?.entity || '';
